import * as React from 'react';
export const NewbuildingLayoutsContext = /*#__PURE__*/React.createContext({
  logger: {},
  httpApi: {}
});